<div class="sh-dashboard-panel" [class.sh-info-widget]="rounded">
  <nav class="sh-dashboard-panel__navigation" [class.sh-info-widget-container__outer]="rounded">
    @if (title) {
      <h3 class="sh-page-title--small-subsection sh-dashboard-panel__navigation__title">{{ title }}</h3>
    }

    <ul class="sh-dashboard-navigation__list" [class.sh-info-widget-container__inner]="rounded">
      @for (link of navigationLinks; track link) {
        <li class="sh-dashboard-navigation__list__item">
          <sh-icon-link [item]="link" class="sh-dashboard-navigation__list__link"></sh-icon-link>
        </li>
      }
    </ul>
  </nav>
</div>
